const C = {
  name: "Apps",
  dimensions: { width: 40, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_27_2074)">
    <path d="M2 15.0029V2.00293H15C15.55 2.00293 16 2.45293 16 3.00293V16.0029H3C2.45 16.0029 2 15.5529 2 15.0029ZM16 0.00292969H2C0.9 0.00292969 0 0.90293 0 2.00293V16.0029C0 17.1029 0.9 18.0029 2 18.0029H16C17.1 18.0029 18 17.1029 18 16.0029V2.00293C18 0.90293 17.1 0.00292969 16 0.00292969Z" />
    <path d="M24 15.0029V2.00293H37C37.55 2.00293 38 2.45293 38 3.00293V16.0029H25C24.45 16.0029 24 15.5529 24 15.0029ZM38 0.00292969H24C22.9 0.00292969 22 0.90293 22 2.00293V16.0029C22 17.1029 22.9 18.0029 24 18.0029H38C39.1 18.0029 40 17.1029 40 16.0029V2.00293C40 0.90293 39.1 0.00292969 38 0.00292969Z" />
    <path d="M2 37.0029V24.0029H15C15.55 24.0029 16 24.4529 16 25.0029V38.0029H3C2.45 38.0029 2 37.5529 2 37.0029ZM16 22.0029H2C0.9 22.0029 0 22.9029 0 24.0029V38.0029C0 39.1029 0.9 40.0029 2 40.0029H16C17.1 40.0029 18 39.1029 18 38.0029V24.0029C18 22.9029 17.1 22.0029 16 22.0029Z" />
    <path d="M24 37.0029V24.0029H37C37.55 24.0029 38 24.4529 38 25.0029V38.0029H25C24.45 38.0029 24 37.5529 24 37.0029ZM38 22.0029H24C22.9 22.0029 22 22.9029 22 24.0029V38.0029C22 39.1029 22.9 40.0029 24 40.0029H38C39.1 40.0029 40 39.1029 40 38.0029V24.0029C40 22.9029 39.1 22.0029 38 22.0029Z" />
    </g>
    <defs>
    <clipPath id="clip0_27_2074">
    <rect width="40" height="40" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  C as Apps
};
